export default __webpack_public_path__ + "static/media/Torpedo-1Open.d2966700.jpg";